var dot = '_1byqy9fb';
var fplThumbBgVar = '--fpl-slider-thumb-bg';
var fplTrackBgVar = '--fpl-slider-track-bg';
var fplTrackBorderColorVar = '--fpl-slider-track-border-color';
var mainDot = '_1byqy9fc';
var range = '_1byqy9fa';
var root = '_1byqy9f6';
var size = {sm:'_1byqy9f4',md:'_1byqy9f5'};
var sliderHeight = 'var(--fpl-slider-height)';
var thumb = '_1byqy9f7';
var thumbBg = '_1byqy9f8 _1q2ok2r5';
var thumbShadow = '_1byqy9f9 _1q2ok2r6';

export { dot, fplThumbBgVar, fplTrackBgVar, fplTrackBorderColorVar, mainDot, range, root, size, sliderHeight, thumb, thumbBg, thumbShadow };
//# sourceMappingURL=slider.css.js.map
